/*
 *  Class BodyOptimizer
 */
export
default class BodyOptimizer {

    constructor() {
        this.markWordBreak = '<wbr>'; // use '&shy;' for word break with delimiter
        this.mailLinks = document.querySelectorAll('a[href*="mailto:"]');
    }

    init() {
      this.beautifyMailBreak();
    }

    beautifyMailBreak() {
      for (let i in this.mailLinks) {
        if (!this.mailLinks[i].innerHTML) continue;
        const labelParts = this.mailLinks[i].innerHTML.split('@');
        this.mailLinks[i].innerHTML = labelParts.join('@' + this.markWordBreak);
      }
    }
}
